import axios from 'axios';

import { type UserConsent } from '../../shared/types/userConsent';

const updateUserConsent = async (userConsent: UserConsent): Promise<void> => {
    await axios.post('/api/update-user-consent', { userConsent });
};

export { updateUserConsent };
